import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import {
  AgreementCompany,
  AgreementCompanyCreate,
} from "@/types/agreementCompany";

export const useAgreementCompaniesDictionary = () => {
  const config = getDictionaryConfig<AgreementCompany, AgreementCompanyCreate>(
    Module.AgreementCompanies,
  );
  return config;
};
